export default "__VITE_ASSET__D0pETgv8__"